<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <path
    class="st0"
    d="M 250 0 C 387.99 0 500 112.01 500 250 C 500 387.99 387.99 500 250 500 C 112.01 500 0 387.99 0 250 C 0 112.01 112.01 0 250 0 Z M 171.814 390.523 L 171.814 195.261 L 106.945 195.261 L 106.945 390.523 L 171.814 390.523 Z M 405.883 390.523 L 405.883 278.595 C 405.883 218.627 373.857 190.768 331.128 190.768 C 296.732 190.768 281.291 209.722 272.631 223.039 L 272.631 195.261 L 207.762 195.261 C 208.66 213.562 207.762 390.523 207.762 390.523 L 272.631 390.523 L 272.631 281.454 C 272.631 275.653 273.04 269.771 274.755 265.604 C 279.412 253.921 290.115 241.912 308.089 241.912 C 331.536 241.912 340.932 259.804 340.932 286.029 L 340.932 390.523 L 405.883 390.523 Z M 139.788 101.144 C 117.566 101.144 103.105 115.768 103.105 134.885 C 103.105 153.595 117.157 168.627 138.971 168.627 L 139.379 168.627 C 162.01 168.627 176.062 153.595 176.062 134.885 C 175.654 115.686 162.01 101.144 139.788 101.144 Z"
  />
</template>
